module.exports = __webpack_public_path__ + "static/img/Knight of Pentacles.9b7f4c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Knight of Pentacles.jpg
// module id = 1280
// module chunks = 0